import React, { Fragment, Component } from "react";
import NavBar from "../../common/forms/NavbarCopy";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Loader } from "../../common/forms/Loading/Loader";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import { BsArrowLeft } from "react-icons/bs";
import { subDirectory } from "../../../config.json";
import "../../../styles/BoardingPassList.scss";
import qrcode from "../../../images/boat/qrcode.png";
import { getBordingPass } from "../../../services/bordingPassService";
import { getLocalStorageValues } from "../../../services/boat";
import {SkBoardingPassCard} from "../../common/skeleton/subcatCardSkeleton"

import { Modal, Divider } from "antd";
class BoardingPassList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      varient: "",
      message: "",
      isTicket: false,
      BoardingPassData: [],
      BoatHouseId: "",
      BookingId: "",
      isBoardingPassAvailable: false,
      isBoardingPassLoading:true
    };
  }

  componentDidMount = async () => {
    await this.BoardingPass();

    await this.setState({ loading: false });
  };
  BoardingPass = async () => {
    await this.setState({ loading: true });
    let data = {
      QueryType: "PBoardingPass",
      UserId: await getLocalStorageValues("UserId"),
    };

    const res = await getBordingPass(data);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({ BoardingPassData: res.data.Response, loading: false,isBoardingPassLoading:false, isBoardingPassAvailable: true });
      }
    } else {
      this.setState({ BoardingPassData: [], loading: false, isBoardingPassLoading:false,isBoardingPassAvailable: false });
    }
  };

  onBoardingTicket = (bookings) => {
    this.props.history.push({
      pathname: `${subDirectory}/boardingPassTicket`,
      state: {
        bookings:bookings,
        BoatHouseId: bookings.BoatHouseId,
        BookingId: bookings.BookingId,
      },
    });
  };
  frameLoadAllBoardingPass = () => {
    const allBookings = this.state.BoardingPassData;

    return allBookings.map((allBookings) => (
      <div className="Boarding-Pass-Card">
        <div className="mb-1" className="content-card-pass">
          <p class="webh-name text-left">{allBookings.BoatHouseName}</p>
          <div className="receiptdisplay">
            <div className="receiptbid"> Booking Id </div>
            <div>:</div>
            <div className="receiptvalue">{allBookings.BookingId} </div>
          </div>
          <div className="receiptdisplay">
            <div className="receiptbid"> Booking Date </div>
            <div className="">:</div>
            <div className="receiptvalue"> {allBookings.BookingDate} </div>
          </div>
          <div className="receiptdisplay">
            <div className="receiptbid"> Premium Status </div>
            <div className="">:</div>
            <div className="receiptvalue"> {allBookings.PremiumStatus}</div>
          </div>
        </div>

        <div>
          {
            <div className="btndisplay">
              {" "}
              <Button className="btn btn-info  mr-3 btn btn-secondary res web-btns" onClick={() => this.onBoardingTicket(allBookings)}>
                Generate Boarding Pass
              </Button>
            </div>
          }
        </div>
      </div>
    ));
  };
  render() {
    const { isBoardingPassAvailable,isBoardingPassLoading, } = this.state;
    return (
      <Fragment>
        {/* <Loader fullPage loading={this.state.loading} /> */}
        <AddNotification visible={false} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <div class="webCheckIn">
          <NavBar {...this.props} />
          <Container fluid className="webCheckIn-con">
          <div className="cancelscroll">
            <Row className="pt-3 mb-3">
              <div className="d-flex mx-auto align-items-end " style={{ width: "90%" }}>
                {/* <div
                  className="d-flex align-items-center  initialpage"
                  style={{ fontSize: "16px", color: "white" }}
                  onClick={() => {
                    this.props.history.goBack();
                  }}
                >
                  <BsArrowLeft className="mr-2" />
                  Back 
                </div> */}
                <div className="webcheck-header d-flex justify-content-center">BOARDING PASS</div>
              </div>
            </Row>
            {!isBoardingPassLoading&&!isBoardingPassAvailable && (
              <div className="Boarding-Pass">
                {" "}
                <div className="Boarding-Pass-nodata">No data found</div>
              </div>
            )}

{isBoardingPassLoading && <div className="Boarding-Pass">  <div className="Boarding-Pass-Card"><SkBoardingPassCard /></div></div>}
            {!isBoardingPassLoading && isBoardingPassAvailable && <div className="Boarding-Pass">{this.frameLoadAllBoardingPass()}
           
            </div>}
            </div>
          </Container>
        </div>
        <></>
      </Fragment>
    );
  }
}
export default BoardingPassList;
